import { __extends, __spread } from 'tslib';
import { createElement, Component } from 'react';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-rating.css';

var UitkRatingIconMap = [
    ['star', 'star'],
    ['alternate', 'brightness_1']
];
var UitkRatingIcons = new Map(UitkRatingIconMap);

var getClassNameList = classNames.bind(styles);
var UitkRating = /** @class */ (function (_super) {
    __extends(UitkRating, _super);
    function UitkRating() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkRating.prototype.render = function () {
        var _a = this.props, a11yText = _a.a11yText, icon = _a.icon, className = _a.className, rating = _a.rating;
        var max = 5;
        var currentRating = Number(rating);
        if (currentRating > max || !currentRating) {
            currentRating > max && console.error("Maximum value is " + max);
            return null;
        }
        var visuallyHiddenText = a11yText
            ? a11yText.replace(/%s/, "" + currentRating).replace(/%d/, "" + max)
            : currentRating + " out of " + max;
        var ratingArr = Number.isInteger(currentRating)
            ? // @ts-ignore
             __spread(Array(currentRating).keys()) : __spread(Array(Math.floor(currentRating)).keys()).concat([currentRating - Math.floor(currentRating)]);
        var wrapperClassNames = getClassNameList('uitk-rating', className);
        var iconType = icon && UitkRatingIcons.get(icon);
        return (createElement("div", { className: wrapperClassNames },
            createElement("span", { className: "is-visually-hidden" }, visuallyHiddenText),
            ratingArr.map(function (val, index) { return (createElement(UitkIcon, { name: Number.isInteger(val) ? "" + iconType : iconType + "_half", size: UitkIconSize.EXTRA_SMALL, key: index, className: getClassNameList('uitk-rating-icon') })); })));
    };
    UitkRating.displayName = 'UitkRating';
    UitkRating.defaultProps = {
        icon: 'star'
    };
    return UitkRating;
}(Component));

export { UitkRating, UitkRatingIcons };
